
import "@/assets/css/styles-v2.css"
import {computed, defineComponent, onMounted, PropType, reactive, ref, toRefs} from 'vue'
import DealDTO from "@/models/DealDTO";
import MoneyDTO from "@/models/MoneyDTO";
import {paymentMethodsHelper} from "@/service/PaymentMethodsHelper"
import {numberFormatter} from "@/service/NumberFormatter"
import InvoiceStateDTO from "@/models/InvoiceStateDTO";
import copyTextToClipboard from "@/service/CopyHelper";
import QRCode from "qrcode-svg";
import SberpayButton from "@/components/PayButtons/SberpayButton.vue";
import {FlowType} from "@/enum/FlowType";
import TPayButton from "@/components/PayButtons/TPayButton.vue";
import { event } from 'vue-gtag'
import AlfapayButton from "@/components/PayButtons/AlfapayButton.vue";
import VTBPayButton from "@/components/PayButtons/VTBPayButton.vue";
import GazprombankButton from "@/components/PayButtons/GazprombankButton.vue";
import PSBPayButton from "@/components/PayButtons/PSBPayButton.vue";
import OzonPayButton from "@/components/PayButtons/OzonPayButton.vue";
import WBPayButton from "@/components/PayButtons/WBPayButton.vue";
import SovkomPayButton from "@/components/PayButtons/SovkomPayButton.vue";
import {requisitesUrl} from "@/service/helper";

const apiUrl = window.API_URL;


export default defineComponent({
  components: {GazprombankButton, PSBPayButton, OzonPayButton, VTBPayButton, AlfapayButton, TPayButton, SberpayButton, WBPayButton, SovkomPayButton},
  props: {
    deal: {
      type: Object as PropType<DealDTO>,
      default: false
    },
    invoice: {
      type: Object as PropType<InvoiceStateDTO>,
      default: false
    },
    sum: {
      type: Object as PropType<MoneyDTO>,
      default: false
    },
    flow: {
      type: Object as PropType<FlowType>,
      default: false
    }
  },
  emits: ['transfer:return-to-merchant', 'transfer:confirm', 'transfer:cancel'],
  setup(props) {
    const qrCode = ref<InstanceType<typeof HTMLElement> | null>(null)

    const state = reactive({
      copyHintTimeout: null as number|null,
      copyValue: '' as string,
      deeplinkClicked: false as boolean
    });

    const requisitesLink = computed(() => requisitesUrl(props.deal))

    const copy = (obj: any, value: string) => {
      state.copyValue = value
      copyTextToClipboard(obj, value);
      if (state.copyHintTimeout) {
        clearTimeout(state.copyHintTimeout)
      }
      state.copyHintTimeout = setTimeout(() => {
        state.copyHintTimeout = null;
      }, 1000);
    }

    const formatCC = (value: string): string => {
      return value
    }

    const openDeeplink = () => {
      event('deeplinkClicked', {})

      if (props.flow === FlowType.SBERPAY && props.deal.paymentOption === 'MOBILE_TOP_UP') {
        const requisite = props.deal.requisites.requisites;
        const digits = requisite.replace(/\D/g, '');
        const shouldTrim = digits.startsWith('996') || digits.startsWith('992');
        copyTextToClipboard(null, shouldTrim ? digits.slice(3) : requisite);
      }

      if (props.flow === FlowType.OZONPAY) {
        const digits = props.deal.requisites.requisites.replace(/\D/g, '');
        copyTextToClipboard(null, digits);
      }

      state.deeplinkClicked = true
      _openDeeplink(0);
    }

    const _openDeeplink = (index: number) => {
      const deeplink = props.invoice.flowData.deeplinks[index]
      event('deeplinkClicked', {link: deeplink})
      window.open(deeplink, "_self")
      index++

      if (!props.invoice.flowData.deeplinks[index]) {
        return;
      }

      setTimeout(() => {
        _openDeeplink(index++);
      }, 1000);
    }

    const isDeeplinkClicked = () => {
      return state.deeplinkClicked
    }


    onMounted(async () => {
      document.addEventListener('visibilitychange', async function (event) {
        if (isDeeplinkClicked()) {
          document.location.reload()
        }
      });

      const theme = props.invoice.flowData?.options?.theme

      const qrcode = new QRCode({
        content: window.location.href,
        join: true,
        container: "svg-viewbox",
        color: theme === 'dark' ? "#fff" : "#000",
        background: theme === 'dark' ? "#000" : "#ECEFF3"
      });

      if (qrCode.value) {
        qrCode.value.innerHTML = qrcode.svg()
      }
    });

    return {
      ...toRefs(state),
      paymentMethodsHelper,
      numberFormatter,
      formatCC,
      copy,
      qrCode,
      apiUrl,
      openDeeplink,
      FlowType,
      requisitesLink,
    }
  }
})
